"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLuyan = void 0;
var react_1 = __importDefault(require("react"));
/**
 * 文字路演
 */
function TextLuyan(props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h1", null,
            "\u89C6\u9891\u8DEF\u6F14 ",
            props.baseinfo.name)));
}
exports.TextLuyan = TextLuyan;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsZ0RBQStDO0FBRy9DOztHQUVHO0FBQ0gsU0FBZ0IsU0FBUyxDQUFDLEtBRXpCO0lBQ0MsT0FBTyxDQUNMO1FBQ0U7O1lBQVUsS0FBSyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQU0sQ0FDbEMsQ0FDSixDQUFBO0FBQ0gsQ0FBQztBQVJELDhCQVFDIn0=